import { Button } from "shared/ui/button"

type LayoutModeToggleProps = {
  mode: "design" | "preview"
  onModeChange: (mode: "design" | "preview") => void
}

export function LayoutModeToggle({ mode, onModeChange }: LayoutModeToggleProps) {
  return (
    <div className="flex justify-end">
      <div className="inline-flex rounded-md border bg-white p-1">
        <Button type="button" size="sm" variant={mode === "design" ? "default" : "ghost"} onClick={() => onModeChange("design")}>
          Design
        </Button>
        <Button type="button" size="sm" variant={mode === "preview" ? "default" : "ghost"} onClick={() => onModeChange("preview")}>
          Preview
        </Button>
      </div>
    </div>
  )
}

